import Service from "@ember/service"
import type { CardAttachment } from "@shared/models/card-stack"
import * as filestack from "filestack-js"

export default class Filestack extends Service {
  readonly client: filestack.Client

  constructor() {
    super(...arguments)
    this.client = filestack.init("AcTuk5i2R9OYgN972g8oBz")
  }

  /**
   * Converts uploaded files from a Filestack.Client method into CardAttachments.
   */
  asAttachments(files): Omit<CardAttachment, "id">[] {
    return files.map((fsFile) => {
      var type = fsFile.mimetype !== null && fsFile.mimetype.match(/image/) ? "image" : "file"

      return {
        url: fsFile.url,
        type: type,
        size: fsFile.size,
        title: fsFile.filename,
        mimetype: fsFile.mimetype,
        isWriteable: fsFile.isWriteable ?? false,
      }
    })
  }
}
